module.exports = __webpack_public_path__ + "img/user.27e729e0.png";